




































































































































































































































































































































































































































import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import http from "@/axios/http-common";
import SuketGawatDarurat from "@/services/SuketGawatDarurat";
import SuketKematian from "@/services/SuketKematian";
import SuketPulang from "@/services/SuketPulang";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";
import { storeResume } from "@/store/modules/resume";
import SuketDirawat from "@/store/modules/SuketDirawat";
import StoreSuketGadar from "@/store/modules/SuketGawatDarurat";
import StoreSuketKematian from "@/store/modules/SuketKematian";
import StoreSuketPulang from "@/store/modules/SuketPulang";
import { storeSuket } from "@/store/modules/suket";
import DialogSuratKeteranganMedis from "@/components/kunjunganPasien/DialogSuratKeteranganMedis.vue";
import ResumeRalanSvc from "@/services/ResumeRalan";
import ResumeCetakMenu from "@/components/resume/ResumeCetakMenu.vue";

@Component({
	components: {
		DialogSuratKeteranganMedis,
		ResumeCetakMenu
	}
})
export default class CardListSuket extends Vue {
	@Prop({ default: null }) register!: string | number;

	dialogSkm = false;

	mounted() {}

	get bisaSkm(): boolean {
		return !!this.register;
	}

	// get arraySk() {
	//   const sk = [];
	//   this.stateRiwayatSuket["suratKonsul"].suratKonsul.map(function(item) {
	//     sk.push(item);
	//   });
	//   sk.push(this.stateRiwayatSuket["suratRujukan"]);

	//   return sk;
	// }
	get stateRiwayatSuket() {
		return storeSuket.riwayatSuket;
	}
	get suketPulangIgd() {
		return StoreSuketPulang.suket;
	}
	get suketGadar() {
		return StoreSuketGadar.suket;
	}
	get suketKematian() {
		return StoreSuketKematian.suket;
	}
	get resume() {
		return storeResume.resume;
	}
	get resumeRanap() {
		return ResumeRanapStore.resume;
	}
	get suketDirawat() {
		return SuketDirawat?.suket;
	}

	cetakResume(id) {
		window.open(ResumeRalanSvc.cetakUrl(id), "_blank");
	}

	cetakSkdp(id) {
		const routeData = http.getAPI() + "/skdp/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSpri(id) {
		const routeData = http.getAPI() + "/spri/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakKonsul(id) {
		const routeData = http.getAPI() + "/surat-konsul/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakRujukan(id) {
		const routeData = http.getAPI() + "/surat-rujukan/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakJawabanRujukan(id) {
		const routeData = http.getAPI() + "/surat-jawaban-rujukan/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkDiagnosa(id) {
		const routeData = http.getAPI() + "/suket-diagnosa/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSuketPulangIgd(id) {
		SuketPulang.print(id);
	}

	cetakSuketGadar(id) {
		SuketGawatDarurat.print(id);
	}

	cetakSuketKematian(id) {
		SuketKematian.print(id);
	}

	cetakSkJasmani(id) {
		const routeData = http.getAPI() + "/suket-sehat-jasmani/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkJiwa(id) {
		const routeData = http.getAPI() + "/suket-sehat-jiwa/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkNapza(id) {
		const routeData = http.getAPI() + "/suket-bebas-napza/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkIstirahat(id) {
		const routeData = http.getAPI() + "/suket-istirahat/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkMata(id) {
		const routeData = http.getAPI() + "/suket-mata/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkParu(id) {
		const routeData = http.getAPI() + "/suket/sehat-paru/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkTht(id) {
		const routeData = http.getAPI() + "/suket/sehat-tht/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkTerbang(id) {
		const routeData = http.getAPI() + "/suket/layak-terbang/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkFit(id) {
		const routeData = http.getAPI() + "/suket/fit-to-work/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkTidakCacat(id) {
		const routeData = http.getAPI() + "/suket/tidak-cacat/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkTatoTindik(id) {
		const routeData = http.getAPI() + "/suket/tato-tindik/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSkPengantarIcu(id) {
		const routeData = http.getAPI() + "/suket/pengantar-icu/" + id + "/pdf";
		window.open(routeData, "_blank");
	}

	cetakSuketDirawat(id) {
		const routeData = http.getAPI() + "/suket/dirawat/" + id + "/pdf";
		window.open(routeData, "_blank");
	}
}
